import {Component, OnDestroy, OnInit} from '@angular/core';
import {ConclusionFormDataService} from '../../services/conclusion-form-data.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {FormGroup} from '@angular/forms';

@Component({
    selector: 'app-conclusion-form-inspection-params',
    templateUrl: './conclusion-form-inspection-params.component.html',
})
export class ConclusionFormInspectionParamsComponent implements OnInit, OnDestroy {

    public hasInspections = false;

    constructor(
        private formService: ConclusionFormDataService,
    ) {
    }

    get form(): FormGroup {
        return this.formService.form;
    }

    ngOnInit() {
        this.formService.inspectionsList$.pipe(
            untilDestroyed(this)
        ).subscribe((list: any[]) => {
            this.hasInspections = Boolean(list.length);
        });
    }

    ngOnDestroy() {

    }
}
